import ENV from '../config/environment';

const URL_HEAD = `${ENV.host}/${ENV.namespace}`;
export const RESET_PASSWORD_ENDPOINT = `${URL_HEAD}/auth/reset`;
export const RECOVERY_PASSWORD_ENDPOINT = `${URL_HEAD}/auth/recovery`;
export const REGISTER_ENDPOINT = `${URL_HEAD}/auth/signup`;
export const LOGOUT_ENDPOINT = `${URL_HEAD}/auth/signout`;
export const LOGIN_ENDPOINT = `${URL_HEAD}/auth/signin`;
export const FACEBOOK_LOGIN_ENDPOINT = `${URL_HEAD}/auth/facebook`;
